import { render, staticRenderFns } from "./CompetitionsList.vue?vue&type=template&id=53e13c59&scoped=true"
import script from "./CompetitionsList.vue?vue&type=script&lang=js"
export * from "./CompetitionsList.vue?vue&type=script&lang=js"
import style0 from "./CompetitionsList.vue?vue&type=style&index=0&id=53e13c59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e13c59",
  null
  
)

export default component.exports